import { z } from "zod";

export const categories = ["AUFGABE", "BAUSTELLE", "MATERIAL", "MASCHINE", "PERSONAL", "KUNDE", "ANGEBOT", "NACHTRAG", "FINANZ", "TERMIN", "DOKUMENT", "NOTIZ", "ENTSCHEIDUNG"] as const;
export const materialStatuses = ["ANGEFORDERT", "PRÜFEN", "BESTELLT", "ABHOLBEREIT", "UNTERWEGS", "GELIEFERT", "ERLEDIGT"] as const;
export const offerStatuses = ["ANFRAGE", "KALKULATION", "ENTWURF", "VERSENDBEREIT", "VERSENDET", "NACHFASSEN", "VERHANDLUNG", "GEWONNEN", "VERLOREN"] as const;
export const provenanceSchema = z.object({
  source: z.enum(["MANUELL", "IMPORT", "DEMO", "LIVE"]),
  sourceId: z.string().trim().min(1).max(200),
  updatedAt: z.iso.datetime(),
  // LIVE requires an explicit verified synchronization time. Local creation is MANUELL.
  synchronizedAt: z.iso.datetime().nullable(),
}).strict().refine(value => value.source !== "LIVE" || value.synchronizedAt !== null, "LIVE_REQUIRES_SYNC");
export type Provenance = z.infer<typeof provenanceSchema>;
export const materialDraftSchema = z.object({
  siteHint: z.string().trim().min(1).max(160),
  material: z.string().trim().min(1).max(160),
  quantity: z.string().regex(/^(?:0|[1-9]\d{0,7})(?:\.\d{1,3})?$/).refine(value => Number(value) > 0),
  unit: z.enum(["t", "kg", "m³", "m²", "m", "Stück"]),
  neededOn: z.iso.date().nullable(),
  priority: z.enum(["KRITISCH", "HOCH", "NORMAL", "NIEDRIG"]),
}).strict();
export type MaterialDraft = z.infer<typeof materialDraftSchema>;
export const inboxDraftSchema = z.object({
  category: z.enum(categories), channel: z.enum(["TEXT", "VOICE", "MANUELL"]),
  title: z.string().trim().min(2).max(160), detail: z.string().trim().max(4000),
  sourceId: z.string().trim().min(1).max(200),
}).strict();
export type InboxDraft = z.infer<typeof inboxDraftSchema>;

// Domain preview only: no storage, network, role mutation or external execution.
export function operationsRisk(category: typeof categories[number], operation: string) {
  const critical = ["PAY", "ORDER", "CONTRACT", "SEND_EMAIL", "SEND_INVOICE", "DATEV", "USER_RIGHTS", "DELETE", "DEPLOY", "PRODUCTION_CONFIG"];
  if (critical.includes(operation)) return "CRITICAL" as const;
  if (operation !== "CAPTURE") return "REVIEW" as const;
  return ["AUFGABE", "NOTIZ", "MATERIAL", "TERMIN"].includes(category) ? "CAPTURE" as const : "REVIEW" as const;
}
